export const auth = {
  base: '/auth',
  login: 'login',
  logout: 'logout',
  emailVerification: 'email-verification'
};

export const base = (workspaceId: number | string = ':workspaceId') => `/workspace/${workspaceId}`;

export const agentBase = (workspaceId: number | string = ':workspaceId', agentId: number | string = ':agentId') =>
  `/workspace/${workspaceId}/agent/${agentId}`;

export const worksheetBase = (workspaceId: number | string = ':workspaceId', agentId: number | string = ':agentId') =>
  `/workspace/${workspaceId}/agent/${agentId}/worksheets`;

export const onBoarding = {
  create: 'create-agent',
  selectAgent: 'select-agent'
};

export const home = {
  performance: 'performance',
  callLogs: 'call-logs',
  configure: 'configure',
  worksheets: ':worksheetId?',
  profile: 'profile'
};

export const configure = {
  identity: 'identity',
  knowledge: 'knowledge',
  action: 'action',
  deployPhone: 'deploy-phone',
  deployWeb: 'deploy-web',
  deployThirdParty: 'deploy-third-party',
  personalizeLink: 'personalized-link'
};

export const business = {
  base: '/setting',
  profile: 'profile',
  billing: 'billing',
  team: 'team',
  operator: 'operator',
  KnowledgeBases: (workspaceId: number | string = ':workspaceId') => `workspace/${workspaceId}/knowledge-bases`,
  KnowledgeBase: (workspaceId: number | string = ':workspaceId') =>
    `workspace/${workspaceId}/knowledge-bases/:knowledgeBaseId`,
  integration: (workspaceId: number | string = ':workspaceId') => `workspace/${workspaceId}/integration`,
  Workflow: (workspaceId: number | string = ':workspaceId') => `workspace/${workspaceId}/workflow`
};

export const knowledgeBase = {
  dataset: 'dataset',
  retrievalTesting: 'retrieval-testing',
  chunks: (datasetId: number | string = ':datasetId', datasetName: string = ':datasetName') =>
    `${datasetId}/${datasetName}`
};

export const agency = {
  base: '/agency',
  // dashboard: '/agency',
  businessProfileEdit: (id = ':businessId') => `businesses/${id}`,
  billing: 'billing',
  businesses: 'businesses',
  usage: '/agency',
  configuration: 'configuration',
  team: 'team',
  integrations: 'integrations',
  agentTemplate: 'agent-templates',
  prompts: 'prompts',
  plans: 'plans',
  integration: 'integrations/:integrationId',
  configureIntegration: 'configure'
};

export const configuration = {
  twilio: 'twilio',
  llm: 'llm',
  stripe: 'stripe',
  smtp: 'smtp',
  pricing: 'pricing',
  branding: 'branding',
  access: 'access'
};

export const publicRoutes = {
  embedPreview: '/embed/talk/preview',
  widget: '/widget',
  previewLink: (workspace: string = ':workspace', agent: string = ':agent') => `/assistant/${workspace}/${agent}`
};
